var _g, _path, _path2, _path3, _path4, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnCacheCleanup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-cache-cleanup",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.388,
    height: 73.144,
    viewBox: "0 0 84.388 73.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16161",
    "data-name": "Group 16161",
    transform: "translate(10.44 10.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12257",
    "data-name": "Path 12257",
    d: "M531.062,1186.1c1.306-3.77,4.084-5.022,7.9-5,15.873.073,31.747.011,47.62.065a11.027,11.027,0,0,1,4.269.812,5.209,5.209,0,0,1,3.15,5.187q-.026,21.088-.015,42.177a10.071,10.071,0,0,1-10.009,10.475c-3.395.128-6.8.023-10.446.023.744-1.336,1.356-2.579,2.124-3.717.2-.3.884-.37,1.349-.379,1.983-.039,3.968,0,5.952-.021,4.282-.04,6.637-2.391,6.639-6.621q.006-15.221,0-30.442v-1.793h-53.9a12.2,12.2,0,0,0-.142,1.316q-.012,15.646,0,31.293a5.922,5.922,0,0,0,5.68,6.221c1.428.147,3.08-.111,4.224.536,1.177.664,1.858,2.206,2.948,3.61-3.811-.141-7.471.579-11-.83a10.438,10.438,0,0,1-6.355-7.647Zm5.1-.083v6.006h32.263v-6.006Zm36.67.016v5.954h6.406v-5.954Zm16.425.035h-6.378v5.953h6.378Z",
    transform: "translate(-531.062 -1181.1)",
    fill: "#347cb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12258",
    "data-name": "Path 12258",
    d: "M580.476,1310.463c-1.958-.473-3.561-.833-5.139-1.281-.184-.052-.228-.593-.281-.745,2.751-1.228,5.585-2.128,8.006-3.676s4.448-3.753,6.789-5.794c2.22,1.453,4.846,3.028,7.306,4.83a10.778,10.778,0,0,0,5.8,2.048c.607.044,1.206.2,1.961.326-1.68,4.681-3.562,9.053-6.926,12.639a6.433,6.433,0,0,1-4.491,2.024c-4.209.326-8.153-.045-11.486-3.463l2.3-2.657c-1.736,0-3.56.437-4.992-.125-1.388-.545-2.373-2.116-3.535-3.236l.329-.542Z",
    transform: "translate(-560.004 -1258.64)",
    fill: "#49a9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12259",
    "data-name": "Path 12259",
    d: "M631.28,1261.07c1.311.731,3.266,1.178,3.545,2.12.474,1.608-.1,3.526-.254,5.5-2.88-.547-5.635-.336-8.022-2.232s-5.05-3.417-7.87-5.286c1.107-1.188,1.967-2.892,3.173-3.19,1.247-.309,2.832.748,4.47,1.271.371-.876.775-1.782,1.14-2.7q2.219-5.6,4.419-11.2c.488-1.239,1.418-2.152,2.705-1.758a4.674,4.674,0,0,1,2.192,2.011c.264.417-.06,1.307-.291,1.918-1.522,4.019-3.092,8.019-4.643,12.027C631.644,1260.057,631.461,1260.579,631.28,1261.07Z",
    transform: "translate(-588.701 -1222.146)",
    fill: "#49a9f5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12260",
    "data-name": "Path 12260",
    d: "M389.429,269.854c-2.4-.684-3.458-1.692-3.613-4.035-.156,2.344-1.214,3.352-3.613,4.035,2.4.684,3.456,1.692,3.613,4.035C385.971,271.546,387.029,270.538,389.429,269.854Z",
    transform: "translate(-354.747 -231.881)",
    fill: "#00aafc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12263",
    "data-name": "Path 12263",
    d: "M389.429,269.854c-2.4-.684-3.458-1.692-3.613-4.035-.156,2.344-1.214,3.352-3.613,4.035,2.4.684,3.456,1.692,3.613,4.035C385.971,271.546,387.029,270.538,389.429,269.854Z",
    transform: "translate(-382.203 -251.945)",
    fill: "#00aafc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12261",
    "data-name": "Path 12261",
    d: "M378.96,212.731c-2.4-.684-3.457-1.691-3.613-4.035-.156,2.344-1.214,3.352-3.612,4.035,2.4.684,3.456,1.692,3.612,4.035C375.5,214.424,376.561,213.415,378.96,212.731Z",
    transform: "translate(-351.594 -161.005)",
    fill: "#00aafc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12262",
    "data-name": "Path 12262",
    d: "M408.876,234.611c-1.657-.472-2.388-1.169-2.5-2.788-.108,1.619-.839,2.316-2.5,2.788,1.657.472,2.388,1.169,2.5,2.787C406.488,235.78,407.218,235.083,408.876,234.611Z",
    transform: "translate(-344.681 -188.917)",
    fill: "#00aafc"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16162",
    "data-name": "Group 16162",
    transform: "translate(79.397 25.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M327.075,212.013c-1.657-.473-2.387-1.169-2.5-2.788-.108,1.619-.838,2.315-2.5,2.788,1.657.472,2.387,1.168,2.5,2.787C324.687,213.181,325.418,212.485,327.075,212.013Z",
    transform: "translate(-322.084 -209.225)",
    fill: "#00aafc"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16163",
    "data-name": "Group 16163",
    transform: "translate(36.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739-2",
    "data-name": "Path 739",
    d: "M327.075,212.013c-1.657-.473-2.387-1.169-2.5-2.788-.108,1.619-.838,2.315-2.5,2.788,1.657.472,2.387,1.168,2.5,2.787C324.687,213.181,325.418,212.485,327.075,212.013Z",
    transform: "translate(-322.084 -209.225)",
    fill: "#00aafc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCacheCleanup);
export default __webpack_public_path__ + "static/media/icn-cache-cleanup.5a4d7a717e4e4548e9a5381390e86136.svg";
export { ForwardRef as ReactComponent };